// extracted by mini-css-extract-plugin
module.exports = {"gridContainer":"TicketItem_gridContainer__N1AQb","gridItem":"TicketItem_gridItem__31ysc"};